module.exports = __webpack_public_path__ + "static/red-queen-bccc953619f9cd67803ce2bc24958f04.jpg";